import { XInput } from '@playcastdotio/CoreTypes';
import clsx from 'clsx';

interface GamepadStateProps {
  prefix: string;
  gamepad: XInput;
  values: {
    east: number;
    north: number;
    south: number;
    west: number;
  };
}

export const ButtonGroup = (props: GamepadStateProps) => {
  const { gamepad, prefix, values } = props;

  return (
    <div className='grid rotate-45 grid-cols-2'>
      <div id={prefix.concat('ButtonNorth')} className='relative size-[5rem]'>
        {prefix.includes('dpad') ? (
          <svg
            width='33'
            height='48'
            viewBox='0 0 33 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.north ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/4 -translate-y-1/3 -rotate-45 scale-[1.4] transform',
            )}
          >
            <g filter='url(#filter0_d_384_3258)'>
              <path
                d='M5.57878 30.3102L15.5949 39.9109C16.2406 40.5298 17.2595 40.5298 17.9052 39.9109L27.9213 30.3102C28.2498 29.9953 28.4355 29.56 28.4355 29.105L28.4356 2.62297C28.4356 1.70101 27.6882 0.953613 26.7662 0.953613L6.73394 0.953611C5.81198 0.953611 5.06458 1.70101 5.06458 2.62297L5.06458 29.105C5.06458 29.56 5.2503 29.9953 5.57878 30.3102Z'
                fill={gamepad.wButtons & values.north ? `rgba(250, 204, 21, 1)` : 'black'}
                fillOpacity='0.75'
                shapeRendering='crispEdges'
              />
              <path
                d='M5.57878 30.3102L15.5949 39.9109C16.2406 40.5298 17.2595 40.5298 17.9052 39.9109L27.9213 30.3102C28.2498 29.9953 28.4355 29.56 28.4355 29.105L28.4356 2.62297C28.4356 1.70101 27.6882 0.953613 26.7662 0.953613L6.73394 0.953611C5.81198 0.953611 5.06458 1.70101 5.06458 2.62297L5.06458 29.105C5.06458 29.56 5.2503 29.9953 5.57878 30.3102Z'
                stroke='white'
                strokeOpacity='0.75'
                strokeWidth='1.66935'
                shapeRendering='crispEdges'
              />
            </g>
            <defs>
              <filter
                id='filter0_d_384_3258'
                x='0.891271'
                y='0.118958'
                width='31.7177'
                height='47.7682'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='3.33871' />
                <feGaussianBlur stdDeviation='1.66935' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_384_3258' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_384_3258' result='shape' />
              </filter>
            </defs>
          </svg>
        ) : (
          <svg
            width='55'
            height='56'
            viewBox='0 0 55 56'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.north ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45 transform',
            )}
          >
            <rect
              x='0.372192'
              y='0.880493'
              width='54.4856'
              height='54.4856'
              rx='27.2428'
              fill={gamepad.wButtons & values.north ? `rgba(250, 204, 21, 1)` : 'black'}
              fillOpacity='0.75'
            />
            <rect
              x='1.48414'
              y='1.99244'
              width='52.2617'
              height='52.2617'
              rx='26.1308'
              stroke='white'
              strokeOpacity='0.75'
              strokeWidth='2.2239'
            />
            <path
              d='M18.4202 16.1824H20.8084L27.5196 26.9291H27.7186L34.4298 16.1824H36.818L28.6473 29.0188V38.8257H26.5909V29.0188L18.4202 16.1824Z'
              fill='white'
              fillOpacity='0.75'
            />
          </svg>
        )}
      </div>
      <div id={prefix.concat('ButtonEast')} className='relative size-[5rem]'>
        {prefix.includes('dpad') ? (
          <svg
            width='49'
            height='32'
            viewBox='0 0 49 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.east ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/4 -rotate-45 scale-[1.4] transform',
            )}
          >
            <g filter='url(#filter0_d_384_3257)'>
              <path
                d='M15.1435 1.53233L5.54279 11.5485C4.92384 12.1942 4.92384 13.213 5.54279 13.8588L15.1435 23.8749C15.4584 24.2034 15.8936 24.3891 16.3486 24.3891L42.8307 24.3891C43.7527 24.3891 44.5001 23.6417 44.5001 22.7197L44.5001 2.68748C44.5001 1.76553 43.7527 1.01813 42.8307 1.01813L16.3486 1.01813C15.8936 1.01813 15.4584 1.20386 15.1435 1.53233Z'
                fill={gamepad.wButtons & values.east ? `rgba(250, 204, 21, 1)` : 'black'}
                fillOpacity='0.75'
                shapeRendering='crispEdges'
              />
              <path
                d='M15.1435 1.53233L5.54279 11.5485C4.92384 12.1942 4.92384 13.213 5.54279 13.8588L15.1435 23.8749C15.4584 24.2034 15.8936 24.3891 16.3486 24.3891L42.8307 24.3891C43.7527 24.3891 44.5001 23.6417 44.5001 22.7197L44.5001 2.68748C44.5001 1.76553 43.7527 1.01813 42.8307 1.01813L16.3486 1.01813C15.8936 1.01813 15.4584 1.20386 15.1435 1.53233Z'
                stroke='white'
                strokeOpacity='0.75'
                strokeWidth='1.66935'
                shapeRendering='crispEdges'
              />
            </g>
            <defs>
              <filter
                id='filter0_d_384_3257'
                x='0.905187'
                y='0.183472'
                width='47.7682'
                height='31.7177'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='3.33871' />
                <feGaussianBlur stdDeviation='1.66935' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_384_3257' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_384_3257' result='shape' />
              </filter>
            </defs>
          </svg>
        ) : (
          <svg
            width='56'
            height='55'
            viewBox='0 0 56 55'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.east ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45 transform',
            )}
          >
            <rect
              x='0.633911'
              y='0.477905'
              width='54.4856'
              height='54.4856'
              rx='27.2428'
              fill={gamepad.wButtons & values.east ? `rgba(250, 204, 21, 1)` : 'black'}
              fillOpacity='0.75'
            />
            <rect
              x='1.74586'
              y='1.58986'
              width='52.2617'
              height='52.2617'
              rx='26.1308'
              stroke='white'
              strokeOpacity='0.75'
              strokeWidth='2.2239'
            />
            <path
              d='M20.8049 38.4233V15.7799H28.4449C29.919 15.7799 31.1463 16.0379 32.1266 16.5538C33.1143 17.0698 33.8551 17.7737 34.3489 18.6656C34.8428 19.5575 35.0897 20.571 35.0897 21.7061C35.0897 22.6496 34.9312 23.4567 34.6143 24.1274C34.2973 24.7982 33.8661 25.3399 33.3207 25.7527C32.7752 26.1655 32.1672 26.464 31.4964 26.6483V26.8252C32.2261 26.8768 32.9337 27.1348 33.6192 27.5991C34.3047 28.0561 34.8686 28.6974 35.3108 29.5229C35.7531 30.3485 35.9742 31.3362 35.9742 32.486C35.9742 33.6285 35.7199 34.6494 35.2113 35.5486C34.7027 36.4405 33.9214 37.1444 32.8674 37.6604C31.8207 38.169 30.4866 38.4233 28.865 38.4233H20.8049ZM22.8725 36.5658H28.865C30.6119 36.5658 31.9018 36.1788 32.7347 35.4049C33.575 34.6309 33.9951 33.658 33.9951 32.486C33.9951 31.6236 33.7851 30.8423 33.3649 30.1421C32.9522 29.4345 32.3662 28.8743 31.607 28.4615C30.8551 28.0487 29.9706 27.8424 28.9534 27.8424H22.8725V36.5658ZM22.8725 26.007H28.6328C29.5247 26.007 30.306 25.8227 30.9768 25.4542C31.6475 25.0857 32.1708 24.5771 32.5468 23.9284C32.9227 23.2798 33.1106 22.539 33.1106 21.7061C33.1106 20.5046 32.72 19.528 31.9387 18.7762C31.1573 18.017 29.9927 17.6374 28.4449 17.6374H22.8725V26.007Z'
              fill='white'
              fillOpacity='0.75'
            />
          </svg>
        )}
      </div>
      <div id={prefix.concat('ButtonWest')} className='relative size-[5rem]'>
        {prefix.includes('dpad') ? (
          <svg
            width='49'
            height='32'
            viewBox='0 0 49 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.west ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/3 -translate-y-1/2 -rotate-45 scale-[1.4] transform',
            )}
          >
            <g filter='url(#filter0_d_384_3256)'>
              <path
                d='M34.3565 23.8749L43.9572 13.8588C44.5762 13.213 44.5762 12.1942 43.9572 11.5485L34.3565 1.53233C34.0416 1.20385 33.6064 1.01813 33.1514 1.01813L6.6693 1.01813C5.74734 1.01813 4.99994 1.76552 4.99994 2.68748L4.99994 22.7197C4.99994 23.6417 5.74734 24.3891 6.6693 24.3891L33.1514 24.3891C33.6064 24.3891 34.0416 24.2034 34.3565 23.8749Z'
                fill={gamepad.wButtons & values.west ? `rgba(250, 204, 21, 1)` : 'black'}
                fillOpacity='0.75'
                shapeRendering='crispEdges'
              />
              <path
                d='M34.3565 23.8749L43.9572 13.8588C44.5762 13.213 44.5762 12.1942 43.9572 11.5485L34.3565 1.53233C34.0416 1.20385 33.6064 1.01813 33.1514 1.01813L6.6693 1.01813C5.74734 1.01813 4.99994 1.76552 4.99994 2.68748L4.99994 22.7197C4.99994 23.6417 5.74734 24.3891 6.6693 24.3891L33.1514 24.3891C33.6064 24.3891 34.0416 24.2034 34.3565 23.8749Z'
                stroke='white'
                strokeOpacity='0.75'
                strokeWidth='1.66935'
                shapeRendering='crispEdges'
              />
            </g>
            <defs>
              <filter
                id='filter0_d_384_3256'
                x='0.826573'
                y='0.183472'
                width='47.7682'
                height='31.7177'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='3.33871' />
                <feGaussianBlur stdDeviation='1.66935' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_384_3256' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_384_3256' result='shape' />
              </filter>
            </defs>
          </svg>
        ) : (
          <svg
            width='55'
            height='55'
            viewBox='0 0 55 55'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.west ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45 transform',
            )}
          >
            <rect
              x='-0.00146484'
              y='0.477905'
              width='54.4856'
              height='54.4856'
              rx='27.2428'
              fill={gamepad.wButtons & values.west ? `rgba(250, 204, 21, 1)` : 'black'}
              fillOpacity='0.75'
            />
            <rect
              x='1.11049'
              y='1.58986'
              width='52.2617'
              height='52.2617'
              rx='26.1308'
              stroke='white'
              strokeOpacity='0.75'
              strokeWidth='2.2239'
            />
            <path
              d='M20.9035 15.7799L27.1725 25.609H27.3162L33.5851 15.7799H36.0286L28.7425 27.1016L36.0286 38.4233H33.5851L27.3162 28.7048H27.1725L20.9035 38.4233H18.4601L25.8568 27.1016L18.4601 15.7799H20.9035Z'
              fill='white'
              fillOpacity='0.75'
            />
          </svg>
        )}
      </div>
      <div id={prefix.concat('ButtonSouth')} className='relative size-[5rem]'>
        {prefix.includes('dpad') ? (
          <svg
            width='33'
            height='49'
            viewBox='0 0 33 49'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.south ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45 scale-[1.4] transform',
            )}
          >
            <g filter='url(#filter0_d_384_3255)'>
              <path
                d='M27.9212 11.6011L17.9051 2.00037C17.2594 1.38142 16.2405 1.38142 15.5948 2.00037L5.57865 11.6011C5.25018 11.9159 5.06445 12.3512 5.06445 12.8062V39.2883C5.06445 40.2102 5.81185 40.9576 6.73381 40.9576H26.7661C27.688 40.9576 28.4354 40.2102 28.4354 39.2883V12.8062C28.4354 12.3512 28.2497 11.9159 27.9212 11.6011Z'
                fill={gamepad.wButtons & values.south ? `rgba(250, 204, 21, 1)` : 'black'}
                fillOpacity='0.75'
                shapeRendering='crispEdges'
              />
              <path
                d='M27.9212 11.6011L17.9051 2.00037C17.2594 1.38142 16.2405 1.38142 15.5948 2.00037L5.57865 11.6011C5.25018 11.9159 5.06445 12.3512 5.06445 12.8062V39.2883C5.06445 40.2102 5.81185 40.9576 6.73381 40.9576H26.7661C27.688 40.9576 28.4354 40.2102 28.4354 39.2883V12.8062C28.4354 12.3512 28.2497 11.9159 27.9212 11.6011Z'
                stroke='white'
                strokeOpacity='0.75'
                strokeWidth='1.66935'
                shapeRendering='crispEdges'
              />
            </g>
            <defs>
              <filter
                id='filter0_d_384_3255'
                x='0.891026'
                y='0.701477'
                width='31.7177'
                height='47.7682'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='3.33871' />
                <feGaussianBlur stdDeviation='1.66935' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_384_3255' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_384_3255' result='shape' />
              </filter>
            </defs>
          </svg>
        ) : (
          <svg
            width='55'
            height='56'
            viewBox='0 0 55 56'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={clsx(
              gamepad.wButtons & values.south ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
              'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45 transform',
            )}
          >
            <rect
              x='0.372192'
              y='0.627686'
              width='54.4856'
              height='54.4856'
              rx='27.2428'
              fill={gamepad.wButtons & values.south ? `rgba(250, 204, 21, 1)` : 'black'}
              fillOpacity='0.75'
            />
            <rect
              x='1.48414'
              y='1.73964'
              width='52.2617'
              height='52.2617'
              rx='26.1308'
              stroke='white'
              strokeOpacity='0.75'
              strokeWidth='2.2239'
            />
            <path
              d='M20.4393 38.573H18.2723L26.5092 15.9297H28.7205L36.9575 38.573H34.7904L27.6923 18.6164H27.5375L20.4393 38.573ZM21.9983 29.8938H33.2315V31.7513H21.9983V29.8938Z'
              fill='white'
              fillOpacity='0.75'
            />
          </svg>
        )}
      </div>
    </div>
  );
};

